import { GetPlanResponseSchema, type GetPlanResponse } from '@vy/api-definition';
import type { Replace } from '@vy/utils';
import { isNotNullOrUndefined, validateNotEmptyObject } from '@vy/utils';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type {
  CustomUseQueryOptions,
  CustomUseQueryOptionsWithoutSuspense,
  CustomUseQueryOptionsWithSuspense,
} from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function usePlanById(
  planId: string,
  options?: CustomUseQueryOptionsWithSuspense<GetPlanResponse>,
): Replace<UseQueryResult<GetPlanResponse>, 'data', GetPlanResponse>;
export function usePlanById(
  planId: string,
  options?: CustomUseQueryOptionsWithoutSuspense<GetPlanResponse>,
): UseQueryResult<GetPlanResponse>;
export function usePlanById(
  planId: string,
  options?: CustomUseQueryOptions<GetPlanResponse>,
): UseQueryResult<GetPlanResponse> | Replace<UseQueryResult<GetPlanResponse>, 'data', GetPlanResponse> {
  const plansApi = getPrivateApi();
  const suspense = options?.suspense ?? true;

  const planQuery = useQuery(
    queryKeys.plans(planId),
    async () => {
      const getPlanResponse = await plansApi.getPlan({ planId });

      return GetPlanResponseSchema.parse(getPlanResponse);
    },
    {
      enabled: isNotNullOrUndefined(planId),
      ...options,
      suspense,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
    },
  );

  if (suspense) {
    validateNotEmptyObject(planQuery.data, `Plan with id ${planId}`);
  }

  return planQuery;
}
